import { useDidMountEffect } from "@hooks/useDidMountEffect";
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
  useState,
} from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "animate.css";
import { moduleType } from "../../../config/module";
import AuthPermission from "../../../types/general/TAuthPermission";
import useAuth from "@/hooks/auth/useAuth";

interface SiderbarItemProps {
  mainModule: moduleType[number];
  // userPermissions: AuthPermission[],
  routedPath: string;
  setRoutedPath: Dispatch<SetStateAction<string>>;
}

const SidebarItem: React.FC<SiderbarItemProps> = ({
  mainModule,
  routedPath,
  // userPermissions,
  setRoutedPath,
}) => {
  const navigate = useNavigate();
  const isRoutedPath = `/${routedPath.split("/")[1]}` === mainModule.path;
  const [isRouted, setIsRouted] = useState(isRoutedPath);

  const handleItemClick = (path: string) => {
    if (path === routedPath) {
      // close menu item
      setRoutedPath("");

      return;
    }
    setRoutedPath(path);
  };

  // const hasSubmodulePermission = useCallback((subModuleMatchId: number) => {
  //     return userPermissions.some(up => up.sub_module_match_id === subModuleMatchId && up.actions.includes("view"));
  // }, []);

  useDidMountEffect(() => {
    setIsRouted(isRoutedPath);
  }, [routedPath]);

  return mainModule.subModules && mainModule.subModules.length > 0 ? (
    <div>
      <div
        className={`flex items-center px-3 py-4 text-sm font-medium rounded-lg ${
          isRouted
            ? "bg-blue-600 text-white"
            : "text-gray-800 hover:bg-gray-100"
        } cursor-pointer transition`}
      >
        <div className="mr-3">{<mainModule.icon />}</div>
        <span>{mainModule.name}</span>
        <div className="ml-auto">
          {isRouted ? (
            <svg
              className="cursor-pointer"
              onClick={() => handleItemClick(mainModule.path)}
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 0 960 960"
              width="20px"
              fill="#ffffff"
            >
              <path d="M357 576L480 453l123 123 57-56-180-180-180 180 57 56ZM480 880q-83 0-156-31.5T197 763q-54-54-85.5-127T80 480q0-83 31.5-156T197 197q54-54 127-85.5T480 80q83 0 156 31.5T763 197q54 54 85.5 127T880 480q0 83-31.5 156T763 763q-54 54-127 85.5T480 880Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
            </svg>
          ) : (
            <svg
              className="cursor-pointer"
              onClick={() => handleItemClick(mainModule.path)}
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 -960 960 960"
              width="20px"
              fill="#6b7280"
            >
              <path d="m480-340 180-180-57-56-123 123-123-123-57 56 180 180Zm0 260q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
            </svg>
          )}
        </div>
      </div>
      {isRouted && (
        <ul className="ml-8 mt-1 space-y-1 text-sm text-gray-600 list-disc">
          {mainModule.subModules.map((subModule) => {
            if (subModule) {
              return (
                <li
                  key={`${mainModule.path}/${subModule.path}`}
                  className="hover:text-blue-600 cursor-pointer"
                  onClick={() =>
                    navigate(`${mainModule.path}${subModule.path}`)
                  }
                >
                  {subModule.name}
                </li>
              );
            }
            return null;
          })}
        </ul>
      )}
    </div>
  ) : (
    <NavLink
      to={mainModule.path}
      className={`flex items-center px-3 py-4 text-sm font-medium rounded-lg ${
        isRouted ? "bg-blue-600 text-white" : "text-gray-800 hover:bg-gray-100"
      } cursor-pointer transition`}
    >
      <div className="mr-3">{<mainModule.icon />}</div>
      <span>{mainModule.name}</span>
    </NavLink>
  );
};

export default SidebarItem;
